// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brand-entry-brandEntry-fca06{bottom:24%;height:auto;position:fixed;right:0;transition:all .38s cubic-bezier(.2,0,.2,1);width:2.43rem;z-index:999}.brand-entry-brandEntry-fca06 .brand-entry-img-4aa76{display:block;height:100%;overflow:hidden;text-align:center;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brandEntry": "brand-entry-brandEntry-fca06",
	"img": "brand-entry-img-4aa76"
};
export default ___CSS_LOADER_EXPORT___;
